module.exports = __webpack_public_path__ + "../resources/img/bg-copy-3-dark.d6063018.svg";